export const getViewportDimensions = () => {
  const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

  return { height, width };
};
